module.exports = __webpack_public_path__ + "static/media/cardOrder_active.cc8363c2.svg";